import { useCallback } from 'react'
import { OutletListItem } from '@ancon/wildcat-types'
import noop from 'lodash/noop'

import useAppDispatch from '../../../store/hooks/useAppDispatch'
import useAppStore from '../../../store/hooks/useAppStore'
import localStorageUtils from '../../app/utils/localStorageUtils'
import { fetchOutletDetails } from '../../outlet/store/outletThunks'
import { outletSelectedOutletTenantIdSelector } from '../../outlet/store/outletSelector'
import { fetchPreOrderSettings } from '../../preOrder/store/preOrderThunks'
import {
  outletsSetSelectedOutletListItem,
  outletsSetSelectedRestaurantId,
} from '../store/outletsSlice'

/**
 * Makes an outlet the selected restaurant, remembered for the next visit,
 * and loads what a company order there needs: its details and the brand's
 * pre-order settings (e.g. the group size limit)
 */
export default function useSelectRestaurant() {
  const dispatch = useAppDispatch()
  const store = useAppStore()

  return useCallback(
    async (outlet: OutletListItem) => {
      dispatch(outletsSetSelectedOutletListItem(outlet))
      dispatch(outletsSetSelectedRestaurantId(outlet.id))
      localStorageUtils.setItem('preSelectedOutletId', outlet.id)

      try {
        await dispatch(fetchOutletDetails({ outletId: outlet.id })).unwrap()

        if (outletSelectedOutletTenantIdSelector(store.getState())) {
          await dispatch(fetchPreOrderSettings()).unwrap()
        }
      } catch (error) {
        noop()
      }
    },
    [dispatch, store],
  )
}
